import React from 'react';
import {Link} from "react-router-dom";
import {ProductsMenu} from "./Products";

export default class ProductsStock extends React.Component {
	constructor(props) {
		super(props);

		let _state = {...props};

		if (!_state.isModule) {
			_state.params = {};
			// window.Route.on({
			// 	'/v2/products/:product_id/stock': (params) => {
			// 		_state = {
			// 			mode: 'list',
			// 			product: false,
			// 			params: params,
			// 			products: [],
			// 			product_price_condition: [],
			// 		};
			// 	},
			// }).match();
			_state.qs = window.Global.getAllQueryStrings();
		}

		this.state = _state;
	}

	componentDidUpdate(prevProps, prevState) {
		if (!this.state.isModule) {
			return;
		}
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.route();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.setState({
				mode: 'list',
				is_loading: true,
				product: false,
				products: [],
				product_price_condition: [],
			}, () => {
				this.fetch();
			})
		}
	}

	route() {
		if (!this.props.location) {
			return;
		}
		window.Route.on({
			'/v2/products/:product_id/stock': (params) => {
				this.setState({
					mode: 'list',
					is_loading: true,
					product: false,
					params: params,
					products: [],
					product_price_condition: [],
				}, () => {
					this.fetch();
				});
			},
		}).match();
	}

	componentDidMount() {
		if (this.state.mode === 'list') {
			this.fetch();
		} else {
			this.route();
		}
	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/product',
			data: {
				product_id: this.state.params.product_id,
				request_data_product_stock_branch: true,
			},
			done: (response) => {
				let product = response.product[0] || false;
				this.setState({
					product: product,
					is_loading: false,
				})

			},
			fail: () => {

			}
		});
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				<div style={{marginBottom: '1rem'}}>
					<div className="flex row wrap middle-xs">
						<div className="ui huge breadcrumb">
							<Link className={"section active"}
							      to={"/v2/products"}>สินค้า</Link>
							{
								this.state.product ?
									<>
										<span className="divider" style={{margin: '0px 1rem'}}>/</span>
										<div className="section">
											{this.state.product.name} ({this.state.product.code})
										</div>
									</>
									: null
							}
							<span className="divider" style={{margin: '0px 1rem'}}>/</span>
							<div className="section active">
								คลังสินค้า
							</div>
						</div>
						<div className="right floated">
							<Link className="ui positive button"
							      to={"/v2/products/new"}>เพิ่มสินค้าใหม่</Link>
						</div>
					</div>
					<ProductsMenu product_id={this.state.product.id} index={1}/>
				</div>
				<div className="flex row wrap">
					{
						this.state.is_loading
							?
							<div className="td center aligned" data-info="nodata">
								<div className="ui active centered inline small loader"/>
							</div>
							:
							<ProductsStock
								mode={"displayQuantityInStock"}
								is_loading={false}
								product={this.state.product}
							/>
					}
				</div>
			</div>
		)
	}

	renderDisplayQuantityInStock() {
		// console.log(this.state);
		let product_stock_all = {
			on_hand: 0,
			incoming: 0,
			available: 0,
			committed: 0,
		}

		if (this.state.product.product_stock.length) {
			this.state.product.product_stock.sort((a, b) => {
				return b.on_hand - a.on_hand;
			})
		}

		let isNoItem = true;

		return (
			<div className="ui basic table Table_root" style={{margin: 0}}>
				<div className="thead">
					<div className="tr">
						<div className="th col-lg-3">คลังสินค้า</div>
						<div className="th col-lg-3">สาขา</div>
						<div className="th col-lg-2-5">ในคลัง</div>
						<div className="th col-lg-2-5">กำลังสั่งซื้อ</div>
						<div className="th col-lg-2-5">พร้อมใช้งาน</div>
						<div className="th col-lg-2-5">เตรียมขาย</div>
					</div>
				</div>
				<div className="tbody">
					{
						this.state.is_loading
							? <div className="tr">
								<div className="td center aligned" data-info="nodata">
									<div className="ui active centered inline small loader"/>
								</div>
							</div>
							: null
					}
					{
						!this.state.is_loading
						&& this.state.product
						&& this.state.product.product_stock.length === 0
						&& (
							!this.state.qs.page
							|| this.state.qs.page === '1'
						) ?
							<div className="tr">
								<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
							</div>
							: null
					}
					{
						!this.state.is_loading
						&& this.state.product
						&& this.state.product.product_stock.length > 0
							?
							this.state.product.product_stock.map((product_stock, product_stock_i) => {
								if (product_stock.on_hand === 0
									&& product_stock.incoming === 0
									&& product_stock.available === 0
									&& product_stock.committed === 0
								) {
									return null;
								}

								isNoItem = false;

								product_stock_all.on_hand += product_stock.on_hand;
								product_stock_all.incoming += product_stock.incoming;
								product_stock_all.available += product_stock.available;
								product_stock_all.committed += product_stock.committed;

								return (
									<div className="tr" key={product_stock_i} style={{cursor: 'default'}}>
										<div className="td col-lg-3">
											{product_stock.stock_name}
										</div>
										<div className="td col-lg-3">
											{product_stock.stock.branch.name}
										</div>
										<div className="td col-lg-2-5">
											{
												product_stock.on_hand === 0
													? '-'
													:
													window.GlobalFunc.getUnitNameByQuantity2({
														'product': this.state.product,
														'quantity': product_stock.on_hand
													})['text']
											}
										</div>
										<div className="td col-lg-2-5">
											{
												product_stock.incoming === 0
													? '-'
													:
													window.GlobalFunc.getUnitNameByQuantity2({
														'product': this.state.product,
														'quantity': product_stock.incoming
													})['text']
											}
										</div>
										<div className="td col-lg-2-5">
											{
												product_stock.available === 0
													? '-'
													:
													window.GlobalFunc.getUnitNameByQuantity2({
														'product': this.state.product,
														'quantity': product_stock.available
													})['text']
											}
										</div>
										<div className="td col-lg-2-5">
											{
												product_stock.committed === 0
													? '-'
													:
													window.GlobalFunc.getUnitNameByQuantity2({
														'product': this.state.product,
														'quantity': product_stock.committed
													})['text']
											}
										</div>
									</div>
								)
							}) : null
					}
					{
						(isNoItem
							&& this.state.product.product_stock.length !== 0)
						&&
						<div className="tr">
							<div className="td col-lg-16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
						</div>
					}
					{
						(product_stock_all.on_hand !== 0
							|| product_stock_all.incoming !== 0
							|| product_stock_all.available !== 0
							|| product_stock_all.committed !== 0
						)
						&&
						<div className="tr">
							<div className="td col-lg-3">รวม</div>
							<div className="td col-lg-3"></div>
							<div className="td col-lg-2-5">
								{
									product_stock_all.on_hand === 0
										? '-'
										:
										window.GlobalFunc.getUnitNameByQuantity2({
											'product': this.state.product,
											'quantity': product_stock_all.on_hand
										})['text']
								}
							</div>
							<div className="td col-lg-2-5">
								{
									product_stock_all.incoming === 0
										? '-'
										:
										window.GlobalFunc.getUnitNameByQuantity2({
											'product': this.state.product,
											'quantity': product_stock_all.incoming
										})['text']
								}
							</div>
							<div className="td col-lg-2-5">
								{
									product_stock_all.available === 0
										? '-'
										:
										window.GlobalFunc.getUnitNameByQuantity2({
											'product': this.state.product,
											'quantity': product_stock_all.available
										})['text']
								}
							</div>
							<div className="td col-lg-2-5">
								{
									product_stock_all.committed === 0
										? '-'
										:
										window.GlobalFunc.getUnitNameByQuantity2({
											'product': this.state.product,
											'quantity': product_stock_all.committed
										})['text']
								}
							</div>
						</div>
					}
				</div>
			</div>
		)
	}

	render() {
		if (!this.state.product) {
			return <div className="ui active centered inline loader"/>
		}
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		if (this.state.mode === 'displayQuantityInStock') {
			return this.renderDisplayQuantityInStock();
		}
		return (
			<>
				PRODUCTS STOCK {this.state.mode}
			</>
		);
	}
}
